import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function DocumentUpload({ conventionId }) {
  const [documents, setDocuments] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (conventionId) {
      api.get(`/documents/${conventionId}`)
        .then(res => setDocuments(res.data))
        .catch(console.error);
    }
  }, [conventionId]);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    setUploading(true);
    setError('');
    try {
      const res = await api.post(`/documents/${conventionId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setDocuments(prev => [res.data, ...prev]);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de l\'upload');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const handleDelete = async (docId) => {
    if (!window.confirm('Supprimer ce document ?')) return;
    try {
      await api.delete(`/documents/${docId}`);
      setDocuments(prev => prev.filter(d => d.id !== docId));
    } catch {
      alert('Erreur lors de la suppression');
    }
  };

  return (
    <div>
      <h3 className="font-medium text-gray-700 mb-3">Pièces jointes</h3>

      <label className="cursor-pointer inline-flex items-center gap-2 border border-dashed border-gray-300 hover:border-blue-400 rounded-lg px-4 py-2.5 text-sm text-gray-600 hover:text-blue-600 transition-colors">
        <span>{uploading ? 'Envoi en cours...' : '+ Ajouter un document'}</span>
        <input
          type="file"
          className="hidden"
          onChange={handleUpload}
          disabled={uploading}
          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
        />
      </label>

      {error && <p className="text-red-600 text-sm mt-2">{error}</p>}

      {documents.length > 0 && (
        <ul className="mt-3 space-y-2">
          {documents.map(doc => (
            <li key={doc.id} className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
              <span className="text-sm text-gray-700 truncate flex-1 min-w-0">{doc.fileName}</span>
              <button
                onClick={() => handleDelete(doc.id)}
                className="text-xs text-red-500 hover:text-red-700 ml-3 shrink-0"
              >
                Supprimer
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
